import { Route, Switch } from "react-router-dom";

import ContentCreateComponent from "../../components/page/promotion/ContentCreateComponent";
import ContentListComponent from "../../components/page/promotion/ContentListComponent";
import CouponCreateComponent from "../../components/page/promotion/CouponCreateComponent";
import CouponListComponent from "../../components/page/promotion/CouponListComponent";

const PromotionMainPage = () => {
  return (
    <Switch>
      <Route
        exact
        path="/promotion/coupon/view"
        component={CouponListComponent}
      />
      <Route
        path="/promotion/coupon/register/:id"
        component={CouponCreateComponent}
      />
      <Route
        path="/promotion/coupon/register"
        component={CouponCreateComponent}
      />
      <Route path="/content/view" component={ContentListComponent} />
      <Route path="/content/register/:id" component={ContentCreateComponent} />
      <Route path="/content/register" component={ContentCreateComponent} />
    </Switch>
  );
};

export default PromotionMainPage;
